/* @ngInject */
const ask = (
  movementRequest,
  movementData,
  utils,
  toaster,
  movementLabels,
  valueHandler
) => {
  const self = {}

  self.delete = (_id, _back = null) => {
    if (valueHandler.isId(_id.id)) { _id = _id.id }

    if (toaster.confirm(movementLabels.ask.delete)) {
      try {
        const message = movementRequest.delete(_id)
        toaster.message(message)
        utils.removeFromArray(movementData.myMovements, _id)
        if (_back) {
          utils.$back()
        }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  return self
}

export default ask



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/services/ask.service.js